import {
  FETCH_INVOICE_REQUEST,
  FETCH_INVOICE_SUCCESS,
  FETCH_INVOICE_FAILURE,
} from './invoiceTypes';

const initialState = {
  loading: false,
  allInvoices: [],
  error: '',
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVOICE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        allInvoices: action.payload,
        error: '',
      };
    case FETCH_INVOICE_FAILURE:
      return {
        ...state,
        loading: false,
        allInvoices: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default invoiceReducer;
